import { EcommerceCartItem } from '@jbhi-fi/utils/src/ga4Tracking/types';
import { AlgoliaProductHit } from '@jbhi-fi/apis/src/algolia/types/AlgoliaProductHit';
import { getMarketplaceTrackingValuesFromHit } from '../utils/helpers';

export const transformAlgoliaHitForTracking = (
  hits: AlgoliaProductHit | Array<AlgoliaProductHit>,
  options?: {
    listName?: string;
    listSlot?: string | unknown;
    listServiceConfig?: string | unknown;
    startIndex?: number;
  }
): Array<EcommerceCartItem> => {
  const transformHit = (hit: AlgoliaProductHit, index?: number) => {
    const gtmProduct = hit.google_tag_manager;
    const reviewCount = hit.product?.numberOfProductReviews;
    const reviewScore = hit.product?.averageProductReviewRating;
    const category = gtmProduct?.category;
    const {
      listName = '(unavailable)',
      listSlot = '(unavailable)',
      listServiceConfig = '(unavailable)',
      startIndex,
    } = options || {};

    let variant = '(unavailable)';
    if (hit.is_family && hit.children) {
      const child = Object.values<{ Values: Array<string>; SKU: string }>(hit.children).find(
        child => child.SKU === hit.sku
      );
      if (child?.Values?.[0]) variant = child.Values[0];
    }

    let listIndex: number | null = null;
    if (index !== undefined) {
      if (startIndex === undefined) {
        listIndex = index + 1;
      } else {
        listIndex = startIndex + index + 1;
      }
    }
    const categories = category ? category.split('/') : [];
    return {
      discount: hit.pricing?.displayWasPrice ? hit.pricing?.saveAmount : 0,
      item_bestseller_flag: hit.all_calculated_product_tags?.join(', ') || '(none)',
      item_brand: gtmProduct?.brand || hit.vendor || '(unavailable)',
      item_category: categories[0],
      item_category2: categories[1],
      item_category3: categories[2],
      item_category4: categories[3],
      item_id: `${hit.is_family ? hit.product?.id || hit.product_id || hit.sku : hit.sku}`,
      item_list_name: listName,
      item_list_slot: listSlot,
      item_list_service_config: listServiceConfig,
      item_name: gtmProduct?.name || hit.title || '(unavailable)',
      item_review_count: reviewCount ?? '(unavailable)',
      item_review_score: reviewScore || '(unavailable)',
      item_variant: variant,
      price: hit.price,
      quantity: 1,
      index: listIndex,
      ...getMarketplaceTrackingValuesFromHit(hit),
    };
  };

  let result = [];
  if (!Array.isArray(hits)) {
    result = [transformHit(hits)];
  } else {
    result = hits.map((hit, index) => transformHit(hit, index));
  }

  return result;
};
